import type { TokenApiDAO } from "@/domains/tokens/types"
import { LcAddress } from "@/domains/core"
import { TokenStore } from "@/domains/tokens/token-store"

/**
 * Build a placeholder `TokenStore` from a thick-v2 pool's embedded token
 * metadata. This mirrors the thick-v1 placeholder factory but tags the token
 * source as `thick-v2` so diagnostics can distinguish indexer origins.
 */
export class ThickV2ApiFactory {
  static createToken(tokenData: {
    address: string
    symbol: string
    name: string
    decimals: number
  }): TokenStore {
    const tokenDAO: TokenApiDAO = {
      address: new LcAddress(tokenData.address),
      symbol: tokenData.symbol,
      name: tokenData.name || tokenData.symbol,
      decimals: tokenData.decimals,
      priceUsd: "0",
      isWhitelisted: false,
      isSwapToken: false,
      isIncentiveToken: false,
      tags: [],
    }

    return new TokenStore(tokenDAO, "system", "thick-v2")
  }
}
